import { VUEX_EXERCISE_MUTATION_NAMES } from "@tt-app/constants";
import {
  ExerciseAccuracyPayload,
  ExerciseAnswerPayload,
  ExerciseLogIdPayload,
  ExerciseNavigationAttemptPayload,
  ExerciseNavigationModalStatusPayload,
  ExerciseNavigationNextFunctionPayload,
  ExerciseSettingsPopupStatusPayload,
  ExerciseState
} from "@tt-app/types";

const {
  ANSWER,
  EXERCISE,
  EXERCISE_ACCURACY,
  EXERCISE_DETAILS,
  EXERCISE_LOADING,
  EXERCISE_LOG_ID,
  EXERCISE_RESULTS,
  HINTS_SETTING,
  IN_PROGRESS,
  LIMITED_MODE_UPDATED,
  LOADING,
  NAVIGATION_MODAL_STATUS,
  NAVIGATION_NEXT_FUNCTION,
  NEXT_PAGE,
  PROCESSING,
  SETTINGS_POPUP_STATUS,
  TOTAL_STATE_RESET
} = VUEX_EXERCISE_MUTATION_NAMES;

const exerciseMutations = {
  [ANSWER](state: ExerciseState, payload: ExerciseAnswerPayload) {
    state.answers[payload.problemUuid] = payload.answer;
  },
  [EXERCISE_DETAILS](state: ExerciseState, payload: any) {
    state.details = payload;
  },
  [EXERCISE_LOADING](state: ExerciseState, payload: boolean) {
    if (payload) {
      state.loading = state.loading + 1;
    } else {
      state.loading = state.loading - 1;
    }
  },
  [EXERCISE](state: ExerciseState, payload: any) {
    state.actual = payload;
  },
  [EXERCISE_LOG_ID](state: ExerciseState, payload: ExerciseLogIdPayload) {
    state.logId = payload.logId;
  },
  [EXERCISE_ACCURACY](state: ExerciseState, payload: ExerciseAccuracyPayload) {
    state.accuracy = {
      ...state.accuracy,
      [payload.problemUuid]: payload.result
    };
  },
  [EXERCISE_RESULTS](state: ExerciseState, payload: any) {
    state.results = payload;
  },
  [HINTS_SETTING](state: ExerciseState, payload: any) {
    state.settings.hints = payload;
  },
  [IN_PROGRESS](state: ExerciseState, payload: boolean) {
    state.inProgress = payload;
  },
  [LIMITED_MODE_UPDATED](state: ExerciseState, payload: ExerciseNavigationAttemptPayload) {
    state.limitedModeUpdated = payload.limitedModeUpdated;
  },
  [LOADING](state: ExerciseState, payload: boolean) {
    if (payload) {
      state.loading = state.loading + 1;
    } else {
      state.loading = state.loading - 1;
    }
  },
  [NAVIGATION_MODAL_STATUS](state: ExerciseState, payload: ExerciseNavigationModalStatusPayload) {
    state.modals.navigation.open = payload;

    if (!payload) {
      state.modals.navigation.next = undefined;
    }
  },
  [NAVIGATION_NEXT_FUNCTION](state: ExerciseState, payload: ExerciseNavigationNextFunctionPayload) {
    state.modals.navigation.next = payload.next;
  },
  [NEXT_PAGE](state: ExerciseState) {
    state.currentPageIndex = state.currentPageIndex + 1;
  },
  [PROCESSING](state: ExerciseState, payload: boolean) {
    if (payload) {
      state.processing = state.processing + 1;
    } else {
      state.processing = state.processing - 1;
    }
  },
  [SETTINGS_POPUP_STATUS](state: ExerciseState, payload: ExerciseSettingsPopupStatusPayload) {
    state.settings.modal.open = payload;
  },
  [TOTAL_STATE_RESET](state: ExerciseState) {
    state.accuracy = undefined;
    state.actual = undefined;
    state.answers = {};
    state.currentPageIndex = 0;
    state.details = undefined;
    state.logId = undefined;
    state.modals.navigation.next = undefined;
    state.modals.navigation.open = false;
    state.results = undefined;
    state.settings.modal.open = false;
  }
};

export { exerciseMutations };
